<template>
  <div>
    <el-cascader
        ref="cascaderPanelRef"
        style="width: 100%"
        v-model="location"
        :props="locationProps"
        :show-all-levels="true"
        :clearable="true"
        :size="'large'"
        :filterable="true"
        :placeholder="$t('page.please-select-area')"
        @change="locationSelected"
    />
  </div>
</template>
<script>
import {
  country, city, province
} from "@/service";
import i18n from "@/i18n";
export default {
  props: {
    selectedLocation: {
      type: [Array],
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      location: [],
      locationOptions: [],
      locationProps: {
        lazy: true,
        lazyLoad(node, resolve) {
          // console.log('node:', node)
          const { level, pathValues } = node
          if (level == 0) {
            // 获取国家
            country({page_size: 0}).then(res => {
              const nodes = res.payload.map(c => {
                return {
                  label: i18n.global.t(`province['${c.name}']`),
                  value: c.id,
                  leaf: false,
                }
              })
              resolve(nodes)
            }).catch(err => {
              console.log('获取国家失败：', err)
            })
          }
          if (level == 1) {
            // 获取省
            province({
              page_size: 0,
              country: pathValues[0]
            }).then(res => {
              const nodes = res.payload.map(p => {
                return {
                  label: i18n.global.t(`province['${p.name}']`),
                  value: p.id,
                  leaf: false,
                }
              })
              resolve(nodes)
            })
          }
          if (level == 2) {
            // 获取市
            city({
              page_size: 0,
              country: pathValues[0],
              province: pathValues[1]
            }).then(res => {
              const nodes = res.payload.map(p => {
                return {
                  label: p.name,   //三级城市未翻译
                  value: p.id,
                  leaf: true
                }
              })
              resolve(nodes)
            })
          }
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    locationSelected(selected) {
      this.$emit('selected', selected)
    },
    clear() {
      this.location = []
    }
  },
  watch: {
    selectedLocation: {
      immediate: true,
      handler(val) {
        if (val && val[0]) {
          this.location = val
        }
      }
    }
  }
}
</script>
<style lang="scss">
.el-popper.el-cascader__dropdown {
  z-index: 3000!important;
}



</style>
